import { attachPublishedVendor, type FetchPublishedVendor } from './attachPublishedVendor'
import {
  IEnum_Solution_Type,
  type IAlspBySlugQuery,
  type IAlspBySlugQueryVariables,
} from './generated/requests'

type BaseAlspBySlug = (
  variables: IAlspBySlugQueryVariables,
  requestHeaders?: any,
) => Promise<IAlspBySlugQuery>

function normalizeSlug(value: string | undefined): string {
  return value?.toLowerCase().trim() ?? ''
}

/**
 * Calls the generated alspBySlug request, then narrows to ALSP-type solutions
 * and picks one by slug (case-insensitive) or by comma-separated oldSlug entries.
 * Replaces nested draft vendor with the published vendor for the same documentId.
 */
export async function alspBySlugCustom(
  baseAlspBySlug: BaseAlspBySlug,
  variables: IAlspBySlugQueryVariables,
  requestHeaders?: any,
  fetchPublishedVendor?: FetchPublishedVendor,
): Promise<IAlspBySlugQuery> {
  const response = await baseAlspBySlug(variables, requestHeaders)
  const solutions =
    response.solutions?.filter((s) => s?.type === IEnum_Solution_Type.Alsp) ?? []

  const targetSlug = normalizeSlug(variables.slug)
  if (!targetSlug) {
    return { solutions: [] }
  }

  const exactMatch = solutions.find((s) => normalizeSlug(s?.slug ?? undefined) === targetSlug)
  const oldSlugMatch = solutions.find((s) => {
    const oldSlug = s?.oldSlug ?? ''
    const parts = oldSlug.split(',').map((part) => normalizeSlug(part))
    return parts.includes(targetSlug)
  })
  const match = exactMatch ?? oldSlugMatch
  if (!match) {
    return { solutions: [] }
  }

  if (!fetchPublishedVendor) {
    return { solutions: [match] }
  }

  const withPublishedVendor = await attachPublishedVendor(match, fetchPublishedVendor, requestHeaders)
  return { solutions: [withPublishedVendor] }
}
